import { MealLogQueries } from './queries';
import { MealLogMutations } from './mutations';

export const MealLog = {
  queries: MealLogQueries,
  mutations: MealLogMutations,
};

export * from './types';
export * from './consumed-date-range';
export * from './meal-slot-grouper';
export * from './meal-log-copy';
